import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="back-to-home">
            ← Volver al inicio
          </Link>
          <h1 className="legal-title">🔒 Política de Privacidad</h1>
          <p className="legal-subtitle">GesOps LLC - Última actualización: Octubre 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Información que Recopilamos</h2>
            <p>
              En GesOps LLC recopilamos únicamente la información necesaria para brindar nuestros servicios de directorio de abogados:
            </p>
            <ul>
              <li><strong>Información de contacto:</strong> Nombre, correo electrónico, teléfono, estado de residencia</li>
              <li><strong>Información del formulario:</strong> Tipo de usuario (inmigrante/abogado/otro) y mensaje</li>
              <li><strong>Información técnica:</strong> Dirección IP, tipo de navegador, páginas visitadas</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. Uso de la Información</h2>
            <p>Utilizamos su información personal para:</p>
            <ul>
              <li>Responder a sus consultas y solicitudes de información</li>
              <li>Conectarle con abogados verificados en nuestro directorio</li>
              <li>Mejorar nuestros servicios y experiencia del usuario</li>
              <li>Enviar comunicaciones relacionadas con nuestros servicios</li>
              <li>Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Compartir Información</h2>
            <p>
              <strong>GesOps LLC NO vende, alquila ni comparte su información personal</strong> con terceros para fines comerciales. 
              Únicamente compartimos información cuando:
            </p>
            <ul>
              <li>Usted nos autoriza expresamente a hacerlo</li>
              <li>Es necesario para conectarle con un abogado de su elección</li>
              <li>Lo requiere la ley o autoridades competentes</li>
              <li>Es necesario para proteger nuestros derechos legales</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Seguridad de Datos</h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizacionales para proteger su información personal:
            </p>
            <ul>
              <li>Cifrado SSL en todas las transmisiones de datos</li>
              <li>Acceso restringido a información personal</li>
              <li>Monitoreo regular de nuestros sistemas</li>
              <li>Capacitación del personal en protección de datos</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Sus Derechos</h2>
            <p>Usted tiene derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> Solicitar una copia de su información personal</li>
              <li><strong>Rectificación:</strong> Corregir información inexacta o incompleta</li>
              <li><strong>Eliminación:</strong> Solicitar la eliminación de su información</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
              <li><strong>Oposición:</strong> Oponerse al procesamiento de sus datos</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Cookies y Tecnologías Similares</h2>
            <p>
              Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Las cookies nos ayudan a:
            </p>
            <ul>
              <li>Recordar sus preferencias de navegación</li>
              <li>Analizar el tráfico y uso del sitio web</li>
              <li>Personalizar contenido y anuncios</li>
              <li>Proporcionar funciones de redes sociales</li>
            </ul>
            <p>Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.</p>
          </section>

          <section className="legal-section">
            <h2>7. Retención de Datos</h2>
            <p>
              Conservamos su información personal solo durante el tiempo necesario para cumplir con los propósitos 
              para los cuales fue recopilada, o según lo requiera la ley aplicable.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Cambios a esta Política</h2>
            <p>
              Nos reservamos el derecho de actualizar esta Política de Privacidad. Los cambios significativos 
              serán notificados a través de nuestro sitio web o por correo electrónico.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contacto</h2>
            <p>
              Para ejercer sus derechos o si tiene preguntas sobre esta Política de Privacidad, contáctenos:
            </p>
            <div className="legal-contact-info">
              <p><strong>GesOps LLC</strong></p>
              <p>📧 Email: info@gesops.com</p>
              <p>🏢 Dirección: 1420 Celebration Blvd, Suite 101, Celebration, FL 34747, Estados Unidos</p>
              <p>💬 WhatsApp Business: [Enlace disponible en el sitio web]</p>
            </div>
          </section>

          <div className="legal-disclaimer">
            <p>
              <strong>Aviso:</strong> GesOps LLC es un directorio de abogados y no proporciona asesoría legal directa. 
              Esta Política de Privacidad se aplica únicamente a los servicios de directorio de GesOps LLC.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
